
import React, { useEffect, useState } from "react";
import { Container, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from "react-router-dom"
import validateBonus from "../utils/validate-bonus";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faExclamation, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { dbAssignLimitedTimeFreeBonus } from "../utils/db-functions";

export default function LimitedTimeFreeBonus() {
    const navigate = useNavigate();
    const user = useSelector((state) => state.user.data);
    const bonuses = useSelector((state) => state.bonuses.list);
    const userLoggedIn = useSelector((state) => state.user.isLoggedIn);
    const bonusArray = Object.entries(bonuses).filter(([key, bonus]) => key.includes('LIMITED_TIME_FREE_BONUS'))[0];
    const bonus = bonusArray ? bonusArray[1] : null;

    const [error, setError] = useState(null);

    const claimNowHandler = async () => {
        try {
            await dbAssignLimitedTimeFreeBonus({ promoCode: bonus?.promoCode });
            navigate(0);
        } catch (error) {
            // console.log((error.response.data.error))
            // console.log(Object.keys(error.response.data.error));
            // console.log('Something went wrong. Please, refresh the page and try again.')
            setError('An error has occured. Please refresh the page. ' + error.response.data.error);
        }
    }

    useEffect(() => {
        //console.log(validateBonus(bonus, user, 'FREE', false))
    });

    /**
     * logged out => register
     * logged in, no deposit => deposit
     * logged in, deposit => claim
     */
    return (
        <>
            {
                bonus && bonus?.isActive && (!userLoggedIn || validateBonus(bonus, user, 'FREE', false)) && (
                    <Container fluid="lg" className="section-margin weekly-bonus-section" >
                        <div className="weekly-bonus-tile-container" >
                            {
                                error && (
                                    <div className="weekly-bonus-timer-container">
                                        <div className="weekly-bonus-timer-wrapper">
                                            <span className="white-100" style={{fontSize: "13px"}}>{error}</span>
                                        </div>
                                    </div>
                                )
                            }
                            <div className="weekly-bonus-image-wrapper">
                                {
                                    userLoggedIn && user?.depositsMade === 0 && (
                                        <img className="limited_free_bonus-lock" src="https://cherryspins.b-cdn.net/bonuses/bonus-lock-1.png" />
                                    )
                                }
                                <img className="weekly-bonus-image" src={bonus?.text?.imageUrl} alt="" />
                            </div>
                            <div className="weekly-bonus-tile-content">
                                <div className="weekly-bonus-tile-content-inner">
                                    <span className="weekly-bonus-badge mb-0">
                                        {bonus?.text?.badge || 'FREE BONUS'}
                                    </span>
                                    <h2 className="subtitle white-100 mb-1">{bonus?.text?.title}</h2>
                                    {
                                        !bonus?.text?.subtitle ? null :
                                            <p className="mb-0">{bonus.text.subtitle}</p>
                                    }
                                    {
                                        userLoggedIn && user?.depositsMade === 0 && (
                                            <p className="mb-0 mt-2 limited_free_bonus-note">
                                                <FontAwesomeIcon icon={faExclamationCircle} />&nbsp;
                                                You need at least one deposit to claim daily free spins.
                                            </p>
                                        )
                                    }
                                    {
                                        userLoggedIn && user?.depositsMade > 0 && (
                                            <p className="mb-0 mt-2 limited_free_bonus-note">
                                                <FontAwesomeIcon icon={faExclamationCircle} />&nbsp;
                                                Claiming this bonus will cancel your current bonus.
                                            </p>
                                        )
                                    }
                                </div>
                                <div className="weekly-bonus-tile-buttons limited_free_bonus-buttons">
                                    {
                                        !userLoggedIn && (
                                            <Link to={`?register`} className="btn-main mt-1 mb-1">Claim now</Link>
                                        )
                                    }
                                    {
                                        userLoggedIn && user?.depositsMade === 0 && (
                                            <Link to={`?quick-deposit`} className="btn-main mt-1 mb-1">Deposit now</Link>
                                        )
                                    }
                                    {
                                        userLoggedIn && user?.depositsMade > 0 && (
                                            <Button onClick={claimNowHandler} className="btn-main mt-1 mb-1">Claim now</Button>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </Container>
                )
            }
        </>
    )
}

// function Timer() {

//     const [timer, setTimer] = useState('');

//     function startAndEndOfWeek() {

//         // If no date object supplied, use current date
//         // Copy date so don't modify supplied date
//         var now = new Date();

//         // set time to some convenient value
//         now.setHours(0, 0, 0, 0);

//         // Get the previous Monday
//         var monday = new Date(now);
//         monday.setDate(monday.getDate() - monday.getDay() + 1);

//         // Get next Sunday
//         var sunday = new Date(now);
//         sunday.setDate(sunday.getDate() - sunday.getDay() + 7);

//         // Return array of date objects
//         //return [monday, sunday];
//         return sunday;
//     }

//     function leadingZero(num) {
//         num = num.toString();
//         while (num.length < 2) num = "0" + num;
//         return num;
//     }

//     useEffect(() => {
//         const sunday = startAndEndOfWeek();
//         let weekEndDay = new Date(sunday);
//         let today = new Date();

//         let _second = 1000;
//         let _minute = _second * 60;
//         let _hour = _minute * 60;
//         let _day = _hour * 24;
//         let distance = Date.parse(weekEndDay) - Date.parse(today);

//         // console.log(new Date(sunday).toISOString())
//         // console.log(new Date().toISOString())

//         let days = Math.floor(distance / _day);
//         let seconds = Math.floor((distance / 1000) % 60);
//         let minutes = Math.floor((distance / 1000 / 60) % 60);
//         let hours = Math.floor((distance / 1000 / 60 / 60) % 24);

//         const timeout = setTimeout(() => {
//             setTimer(`${leadingZero(days)}:${leadingZero(hours)}:${leadingZero(minutes)}:${leadingZero(seconds)}`)
//         }, 1000);

//         return () => {
//             clearTimeout(timeout);
//         }
//     }, [timer])

//     return (
//         <div className="weekly-bonus-timer-container">
//             <div className="weekly-bonus-timer-wrapper">
//                 <FontAwesomeIcon icon={faClock} className="white-100 me-2" />
//                 <span className="weekly-bonus-expires-in mb-1">Expires in:&nbsp;&nbsp;</span>
//                 <span className="weekly-bonus-timer mb-0">{timer}</span>
//             </div>
//         </div>
//     )
// }